import React, { useRef, useEffect } from 'react';
import './QuestionStyles.css';

/**
 * Question Component
 * 
 * Renders a single question and its answer options with improved scrolling behavior.
 */
function Question({
  data,
  isCurrentQuestion,
  handleAnswerOptionClick,
  selectedAnswer,
  setSelectedAnswer,
  isVisible,
  questionRef
}) {
  const internalRef = useRef(null);
  const ref = questionRef || internalRef;
  
  // Add class for intersection observer visibility state - with null check
  useEffect(() => {
    if (ref.current && isVisible) {
      ref.current.classList.add('question-in-view');
    } else if (ref.current) {
      ref.current.classList.remove('question-in-view');
    }
  }, [isVisible, ref]);

  // Enhanced onClick handler that highlights the element when selected - with null check
  const handleOptionClick = (dimension, value) => {
    // Apply the highlight class with null check
    if (ref.current) {
      ref.current.classList.add('highlight-active');
      setTimeout(() => {
        if (ref.current) {
          ref.current.classList.remove('highlight-active');
        }
      }, 1000);
    }
    
    // Update state and call parent handler
    setSelectedAnswer(value);
    handleAnswerOptionClick(dimension, value, data.id);
  };

  return (
    <div
      className={`question ${
        isCurrentQuestion
          ? 'current'
          : (selectedAnswer === undefined ? 'inactive' : '')
      }`}
      id={`question-${data.id}`}
      ref={ref}
    >
      <h1>{data.question}</h1>
      <div className="likert-scale">
        {[-3, -2, -1, 0, 1, 2, 3].map((value, index) => (
          <div key={value} className="likert-option">
            <input
              type="radio"
              id={`option-${value}-${data.id}`}
              name={`answer-${data.id}`}
              value={value}
              checked={selectedAnswer === value}
              onChange={() => handleOptionClick(data.dimension, value)}
            />
            <label
              htmlFor={`option-${value}-${data.id}`}
              className={`likert-circle likert-circle-${index}`}
            ></label>
          </div>
        ))}
      </div>
    </div>
  );
}



export default Question;
